<template>
  <div class="px-4 md:px-4 my-6">
    <div
      class="block bg-lightGreenBg text-center text-gray-800 py-[100px] px-8 w-full mx-auto"
    >
      <h2 class="text-xl sm:text-3xl mb-4">
        {{ title }}
      </h2>
      <div class="text-base sm:text-lg mb-6" v-html="text" />

      <VuepalLink :to="link?.uri?.path" class="is-filled button bg-lightGreen">
        {{ $texts('newsletter.subscribe') }}
        <SpriteSymbol name="arrow-right" class="size-6" />
      </VuepalLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ParagraphNewsletterFragment } from '#graphql-operations'

defineProps<{
  title: ParagraphNewsletterFragment['title']
  text: ParagraphNewsletterFragment['text']
  link: ParagraphNewsletterFragment['link']
}>()

defineBlokkli({
  bundle: 'newsletter',
})
</script>
